/* Mobile sticky add-to-cart: show the bar once the real Add to cart button has scrolled
   above the viewport, on screens narrower than 750px. No dependencies. */
(() => {
  const bar = document.querySelector('[data-sticky-atc]');
  if (!bar || !('IntersectionObserver' in window)) return;

  const formId = bar.querySelector('button[form]')?.getAttribute('form');
  const form = formId ? document.getElementById(formId) : null;
  const target = form ? form.querySelector('[type="submit"]') || form : null;
  if (!target) return;

  const mobile = window.matchMedia('(max-width: 749px)');
  let scrolledPast = false;

  const update = () => {
    bar.hidden = !(mobile.matches && scrolledPast);
    document.body.classList.toggle('sticky-atc-visible', !bar.hidden);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      });
      update();
    },
    { threshold: 0 }
  );

  observer.observe(target);
  mobile.addEventListener('change', update);
})();
